import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownFull = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 6, viewBox: "0 0 10 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.23795 0.600586C9.17325 0.600586 9.59665 1.77004 8.87813 2.36881L5.64018 5.0671C5.26934 5.37614 4.73066 5.37614 4.35982 5.0671L1.12186 2.3688C0.403349 1.77004 0.826754 0.600585 1.76205 0.600586L8.23795 0.600586Z", fill: "#DEDCD6" }));
const ForwardRef = forwardRef(SvgArrowDownFull);
export default ForwardRef;
